import React, { useEffect, useState } from 'react';
import styles from './ChatConsoleSidebar.module.scss';
import ChatHeader from './components/chat-header/ChatHeader';
import Chats from './components/chat-body/Chats';
import Button from 'component/atom/forms/button/Button';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { isEmpty } from 'lodash';

const ChatConsoleSidebar = ({
  isOpen,
  setIsOpen,
  botId,
  getActiveChat,
  chatsData,
  onNewChatClick,
  ChatId,
  onSearch,
  refetchChatsList,
  isLoading,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentChat, setCurrentChat] = useState('');

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setCurrentChat(ChatId);
  }, [ChatId]);

  return (
    <div className={styles['chat-sidebar']}>
      <ChatHeader
        onMenuClick={setIsOpen}
        isOpen={isOpen}
        handleExpand={handleExpand}
        isExpanded={isExpanded}
        onSearch={onSearch}
        onNewChatClick={onNewChatClick}
      />

      <div className={styles['chat-body']}>
        {!isEmpty(chatsData) ? (
          <Chats
            data={chatsData?.slice().reverse()}
            title='today'
            isExpanded={isExpanded}
            getActiveChat={getActiveChat}
            currentChat={currentChat}
            refetchChatsList={refetchChatsList}
          />
        ) : isEmpty(chatsData) && !isLoading ? (
          <div className={styles['no-data']}>
            <SvgWithBranding type='noChat' />
            <p>No Chat Found</p>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ChatConsoleSidebar;
